/**
 * LA Kings Theme Configuration
 * All client-specific colors, logos, and styling values
 */

const kingsTheme = {
    // Client identification
    clientId: 'kings',
    clientName: 'LA Kings',

    // Client-specific features (absent/false in other themes)
    features: { pacing: true, benchmark: true },

    // Logo configuration
    logos: {
        primary: require('../../components/Login/images/kings2.png'),
        primaryHeight: '85px',
        secondary: require('../../components/Login/images/theteam.png'),
        secondaryHeight: '52px',
    },

    // Channel colors and gradients
    // Note: Kings uses gray gradient cards (wassaman style), colors are for charts only
    channels: {
        social: {
            color: '#4444A5',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        digital: {
            color: 'yellow',
            colorHex: '#FFFF00',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        highlights: {
            color: '#FF9027',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        linear: {
            color: '#70dbff',
            colorAlt: '#44A1A5', // Used in BarChart3D, ComparisonCard
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        tv: {
            color: '#44A1A5',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        invenue: {
            color: '#44A1A5',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        ooh: {
            color: '#A5449B',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
        sponsorship: {
            color: '#55FF00',
            gradient: ['#9ea4a7', '#9ea4a7'], // Gray (wassaman)
        },
    },

    // Gradient card text color
    gradientCardText: 'black',

    // Background colors
    backgrounds: {
        page: 'black',
        loginPage: 'rgb(18, 18, 18)',
        panel: '#161A1C',
        panelDark: 'hsl(200 12% 10%)',
        panelMid: 'hsl(200 12% 17%)',
        panelAlt: 'hsl(200 12% 20%)',
        panelLight: 'hsl(200 12% 30%)',
        modal: '#333',
    },

    // Text colors
    text: {
        primary: 'white',
        secondary: 'burlywood',
        highlight: 'chartreuse',
        onLight: 'black',
        link: '#0097FA',
        wheat: 'wheat',
    },

    // Button colors
    buttons: {
        primary: 'hsl(180 100% 50%)', // Login button - cyan
        dashboard: 'violet',
        viz3d: 'teal',
        rawdata: 'grey',
        apply: 'blue',
        save: 'green',
        reset: 'blue',
        refresh: 'teal',
    },

    // Accent colors
    accents: {
        primary: 'violet',
        secondary: 'teal',
        tertiary: '#AF1B96', // Magenta for tabs
        tab1: 'chartreuse',
        tab2: 'cyan',
        tab3: '#AF1B96',
    },

    // Navigation colors
    navigation: {
        background: 'black',
        iconColor: '#1e90ff',
        iconActiveColor: '#0097FA',
        iconHighlight: 'yellow',
    },

    // Label colors
    labels: {
        brand: 'orange',
        asset: 'violet',
        channel: 'teal',
        comparison: 'blue',
        ribbon: 'blue',
    },

    // Shadow styles
    shadows: {
        card: 'hsl(200 12% 30%) 0 0 4px',
        cardLarge: 'hsl(200 12% 30%) 0 0 8px',
        image: '#020202 9px 10px 20px 2px',
    },

    // Gauge/Speedometer colors
    gauge: {
        stages: [
            [0.09, 'red'],
            [0.25, 'red'],
            [0.45, '#ff4500'],
            [0.7, '#0F9FE7'],
            [1, '#12E438'],
        ],
        text: '#fff',
        detail: '#333',
        shadow: '#fff',
    },

    // Table row color palette for alternating rows
    tableRows: [
        '#161A1C',
        '#4C464F',
        '#4F7E7A',
        '#AD3498',
        '#AD345B',
        '#B46C1D',
        '#B1B41D',
        '#7E4F77',
        '#7E4F60',
        '#7E564F',
        '#637E4F',
        '#4F727E',
        '#564F7E',
    ],

    // Form element colors
    forms: {
        loginFormBackground: 'black',
        loginFormOpacity: '0.7',
        dropdownBackground: 'violet',
        dropdownText: 'black',
        inputBackground: '#333',
        inputText: 'chartreuse',
    },

    // Progress bar colors
    progressBar: {
        background: 'hsl(199 12% 30%)',
        fill: 'violet',
        tiny: '#333',
    },

    // Scrollbar colors
    scrollbar: {
        track: '#161A1C',
        thumb: '#333',
    },

    // Chart-specific colors
    charts: {
        axisLabel: '#6a7985',
        axisLine: 'white',
        tooltipBackground: '#6a7985',
    },
};

export default kingsTheme;
